import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle';

import { useApplication } from '../AppContext';

const ComputerMenu = () => {

	const { t } = useTranslation();
	const app = useApplication();
	const [hasSavedGame, setSavedGame] = React.useState(false);
	const [showForfeitDialog, setShowForfeitDialog] = React.useState(false);

	React.useEffect(() => {
		(async () => {
			const hasSavedGame = await app.getSavedGameState();

			////there is a saved game, but has not started yet.
			////this is needed becaues there is no new game button at the end of the game where it can sit at gameover
			// if(hasSavedGame && hasSavedGame.rounds && hasSavedGame.rounds.length === 0) {
			// 	hasSavedGame = null;
			// }
			if (!hasSavedGame) { //if we don't have a saved game, no reason to stick around.
				app.navigate('Game/Classic/Easy');
			} else {
				setSavedGame(true);
			}
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
    
	const navigate = React.useCallback((event, page) => {
		event.preventDefault();
		app.navigate(page);
	}, [app]);

	const continueButton = React.useMemo(() => {
		if (!hasSavedGame) {
			return null;
		}

		return (
			<li>
				<a href="#Game/Continue/Easy" className="button buttonMedium" onClick={event => navigate(event, 'Game/Continue/Easy')}>
					{t('Continue')}
				</a>
			</li>
		);
	}, [hasSavedGame, t, navigate]);

	const handleNewGameClick = (e) => {
		e.preventDefault();
		//for now, we just navigate to a new game.
		app.navigate('Game/Classic/Easy');
		//     if (hasSavedGame) {
		//         setShowForfeitDialog(true);
		//     } else {
		//         app.navigate('Game/Classic/Easy');
		//     }
	};

	const handleForfeitYes = () => {
		//todo: forfeit the game
		// this could be a call to the game manager to reset the game state.
		// For now, we just navigate to a new game.
		app.navigate('Game/Classic/Easy');
		setShowForfeitDialog(false);
	};

	const handleForfeitNo = () => {
		setShowForfeitDialog(false);
	};

	return (

		<div id="ComputerMenu1" className="page1">
			<div className="wrapper">
				<PageTitle>
					<h1></h1>
				</PageTitle>
				<ul className="buttonList">
					{continueButton}
					<li className="divider" role="separator"></li>
					<li>
						<a href="#Game/Classic/Easy" className="button buttonEasy" onClick={handleNewGameClick}>
							{t('Easy')}
						</a>
					</li>
					<li>
						<a href="#Game/Classic/Medium" className="button buttonMedium" onClick={event => navigate(event, 'Game/Classic/Medium')}>
							{t('Medium')}
						</a>
					</li>
					<li>
						<a href="#Game/Classic/Hard" className="button buttonHard" onClick={event => navigate(event, 'Game/Classic/Hard')}>
							{t('Hard')}
						</a>
					</li>
					<li>
						<a href="#Game/Classic/CrazyNinja" className="button buttonCrazyNinja" onClick={event => navigate(event, 'Game/Classic/CrazyNinja')}>
							{t('CrazyNinja')}
						</a>
					</li>

				</ul>
				{showForfeitDialog && (
					<div className="yesNoDialog">
						<p>{t('A game is already in progress. Do you want to forfeit the current game and start a new one?')}</p>
						<button 
							className="simpleButtonOutLine"
							onClick={handleForfeitYes}
						>
							{t('Yes')}
						</button>
						<button
							className="simpleButtonOutLine "
							onClick={handleForfeitNo}
						>
							{t('No')}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default React.memo(ComputerMenu);
